export const LOAN_PROCESSING_BATCHES_DASHBOARD_DIRTY_EVENT = 'caat-loan-batch-queues-dirty';

/** When set, Application Loan Tracking tab refetches only if the open application matches. */
export const APPLICATION_LOAN_TRACKING_REFRESH_EVENT = 'caat-application-loan-tracking-refresh';

/** Refetch EDO Loan Batch lists (dashboard queue sections, Manage Batch Processing) via window event listeners. */
export function notifyLoanProcessingBatchesDashboardDirty() {
  window.dispatchEvent(new CustomEvent(LOAN_PROCESSING_BATCHES_DASHBOARD_DIRTY_EVENT));
}

/**
 * After batch withdraw/reset-all, refresh Loan Tracking if this application is open.
 * @param {{ applicationId?: number, applicationIds?: number[] }} detail
 */
export function notifyApplicationLoanTrackingRefresh(detail) {
  window.dispatchEvent(new CustomEvent(APPLICATION_LOAN_TRACKING_REFRESH_EVENT, { detail: detail || {} }));
}
